import { render, staticRenderFns } from "./certificateDet_user.vue?vue&type=template&id=7b623d21&scoped=true&"
import script from "./certificateDet_user.vue?vue&type=script&lang=js&"
export * from "./certificateDet_user.vue?vue&type=script&lang=js&"
import style0 from "./certificateDet_user.vue?vue&type=style&index=0&id=7b623d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b623d21",
  null
  
)

export default component.exports